<div>
  <app-user-form-new [data]="data"></app-user-form-new>
</div>
